import { Sector } from '../model/sector';

export function sectorToString(sector: Sector): string {
  if (sector === Sector.Transport) {
    return 'transport';
  }
  if (sector === Sector.Industry) {
    return 'industry';
  }
  if (sector === Sector.Agriculture) {
    return 'agriculture';
  }
  if (sector === Sector.Energy) {
    return 'energy';
  }
  if (sector === Sector.Other) {
    return 'other';
  }
  return 'none';
}
